window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-modal]').forEach(item => {
    item.addEventListener('click', event => {
      event.preventDefault()
      const modalId = item.getAttribute('data-modal')
      window.showModal(modalId);

    });
  });

  document.querySelectorAll('.modal').forEach(modal => {
    modal.querySelector('.btn-close').addEventListener('click', event => {
      event.preventDefault()
      const modalId = modal.getAttribute('id');
      window.hideModal(modalId);
    });
    modal.addEventListener('click', event => {
      if (!event.target.closest('.modal-box')) {
        const modalId = modal.getAttribute('id');
        window.hideModal(modalId);
      }
    })
  })
})


window.showModal = (modalId) => {
  const modal = document.getElementById(modalId);
  if (modal) {
    modal.classList.add('--active');
    document.body.classList.add('--modal-opened');
    if (window.lenis) {
      window.lenis.stop();
    }
    modal.querySelectorAll('video').forEach((video, index) => {
      video.pause();
      video.currentTime = 0;
      if (index === 0) {
        video.play();
      }
    });

    if (modal.querySelector('.video-nav')) {
      const videoNav = modal.querySelector('.video-nav');
      videoNav.querySelectorAll('a')[0].click();
    }
  }
}

window.hideModal = (modalId) => {
  const modal = document.getElementById(modalId);
  if (modal) {
    modal.classList.remove('--active');
    const activeModalCount = document.querySelectorAll('.modal.--active').length;
    if (activeModalCount === 0) {
      document.body.classList.remove('--modal-opened');
      if (window.lenis) {
        window.lenis.start();
      }
    }
    modal.querySelectorAll('video').forEach(video => {
      video.pause();
    });
  }
}